import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ClipMask from '../../components/ClipMask/index';
import { getArticleList } from '../../service/article';
import { useSelectTag } from '../../hooks/useSelectData';
import type { ArticlePost } from '@/types';
import './index.scss';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [featuredPosts, setFeaturedPosts] = useState<ArticlePost[]>([]);
  const { data: tags } = useSelectTag();

  useEffect(() => {
    getArticleList({ isFeatured: '1', page: 1, pageSize: 9 }).then((res) => {
      if (res?.success) {
        setFeaturedPosts(res.data.list);
      }
    });
  }, []);

  const goToDetail = (postsId: number) => {
    navigate(`/blog/article/${postsId}`);
  };

  const getTagLabel = (tagValue?: string) => {
    if (!tagValue) return '';
    return tags.find((t) => t.value === tagValue)?.label || tagValue;
  };

  const handleExploreClick = () => {
    navigate('/demo');
  };

  return (
    <div className="home-container">
      <div className="hero-section">
        <div className="glass-card">
          <h1 className="hero-title">欢迎来到我的博客</h1>
          <p className="hero-subtitle">记录技术成长，分享编程乐趣</p>
          <button className="cta-button" onClick={handleExploreClick}>
            开始探索
          </button>
        </div>
      </div>
      <div className="clip-mask-section">
        <ClipMask
          baseImage="https://xterminal.cn/app_white2.png"
          effectImage="https://xterminal.cn/_nuxt/1767254277616/app_blacked2DCjThr-q.png"
        />
      </div>
      <div className="featured-section">
        <h2 className="section-title">精选文章</h2>
        <div className="articles-grid">
          {featuredPosts.map((post) => (
            <article
              key={post.postsId}
              className="blog-post"
              onClick={() => goToDetail(post.postsId)}
            >
              <div className="post-meta">
                <span className="post-category">
                  {getTagLabel(post.tag)}
                </span>
                <span className="post-date">{post.published_at?.slice(0, 10)}</span>
                <span className="post-views">👁 {post.view_count}</span>
              </div>
              <h3 className="post-title">{post.title}</h3>
              <p className="post-excerpt">{post.summary}</p>
              <button
                className="read-post-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  goToDetail(post.postsId);
                }}
              >
                阅读全文
              </button>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
